'use client';

export { default } from './Tabs';
export { default as tabsClasses } from './tabsClasses';
export * from './tabsClasses';


//////////////////
// WEBPACK FOOTER
// ../@mui/material/Tabs/index.js
// module id = 901
// module chunks = 22